import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { app } from '../firebase';

const SignIn: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const auth = getAuth(app);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/dashboard');
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 flex flex-col">
            {/* Header */}
            <header className="bg-gray-800 py-4">
                <div className="container mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center gap-3">
                    <img src="/images/logo.png" alt="Fixisy Logo" className="h-8 w-8 sm:h-10 sm:w-10 object-contain" />
                    <Link to="/" className="text-xl sm:text-2xl font-bold text-cyan-400">Fixisy</Link>
                </div>
            </header>
            {/* Main Content */}
            <main className="flex-1 flex flex-col items-center justify-center px-4 py-8">
                <div className="w-full max-w-xs sm:max-w-md">
                    <div className="mb-6 sm:mb-8 text-center">
                        <h1 className="text-2xl sm:text-3xl font-bold text-white">Sign In</h1>
                    </div>
                    {/* Error message */}
                    {error && <div className="mb-4 text-red-400 text-center text-sm">{error}</div>}
                    {/* Sign In Form */}
                    <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                        <div>
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg bg-gray-800 text-white border border-gray-700 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 text-sm sm:text-base"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg bg-gray-800 text-white border border-gray-700 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 text-sm sm:text-base"
                                required
                            />
                        </div>
                        <div className="text-right">
                            <Link to="/forgot-password" className="text-xs sm:text-sm text-cyan-400 hover:text-cyan-300">
                                Forgot Password?
                            </Link>
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-cyan-500 text-white py-3 rounded-lg font-semibold hover:bg-cyan-600 transition-colors text-sm sm:text-base"
                        >
                            Login
                        </button>
                    </form>
                    <div className="mt-4 text-center">
                        <span className="text-gray-400 text-xs sm:text-sm">Don't have an account?</span>
                        <Link to="/signup" className="ml-2 text-cyan-400 hover:text-cyan-300 font-semibold text-xs sm:text-sm">
                            Sign Up
                        </Link>
                    </div>
                </div>
            </main>
            {/* Footer */}
            <footer className="py-6 sm:py-8 bg-gray-800 mt-auto">
                <div className="container mx-auto px-4 sm:px-6">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0">
                        <div className="text-gray-400 mb-2 sm:mb-0 text-center sm:text-left text-xs sm:text-base">
                            © {new Date().getFullYear()} Kifayti Retail Private Limited. All rights reserved.
                        </div>
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 items-center">
                            <Link to="/terms" className="text-gray-400 hover:text-cyan-400">
                                Terms & Conditions
                            </Link>
                            <Link to="/privacy" className="text-gray-400 hover:text-cyan-400">
                                Privacy Policy
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default SignIn; 